import React from "react";
import SiteDocumentation from "./SiteDocumentation";

export default function XMQ_doc_cluster() {
    return <SiteDocumentation page="cluster"/>;
}
